/* ============================================================
   SOULFRESH THEME – Main JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ---- Sticky Header ---- */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 20) {
        header.style.background = 'rgba(13,15,20,0.97)';
      } else {
        header.style.background = 'rgba(13,15,20,0.85)';
      }
    }, { passive: true });
  }

  /* ---- Cart Count Update ---- */
  function updateCartCount(count) {
    const el = document.getElementById('cart-count');
    if (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  /* ---- Fetch Cart ---- */
  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  fetchCart();

  /* ---- Add to Cart (AJAX) ---- */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const btn = productForm.querySelector('.btn-atc');
      const originalText = btn ? btn.textContent : '';

      if (btn) {
        btn.textContent = 'Wird hinzugefügt…';
        btn.disabled = true;
      }

      const formData = new FormData(productForm);
      const data = {};
      formData.forEach(function (value, key) { data[key] = value; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: data.id, quantity: parseInt(data.quantity) || 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart add failed');
          return r.json();
        })
        .then(function () {
          fetchCart();
          if (btn) {
            btn.textContent = '✓ Hinzugefügt!';
            btn.style.background = '#4ade80';
            btn.style.borderColor = '#4ade80';
            btn.style.color = '#0d0f14';
            setTimeout(function () {
              btn.textContent = originalText;
              btn.style.background = '';
              btn.style.borderColor = '';
              btn.style.color = '';
              btn.disabled = false;
            }, 2000);
          }
        })
        .catch(function () {
          if (btn) {
            btn.textContent = 'Fehler – bitte erneut versuchen';
            btn.disabled = false;
            setTimeout(function () {
              btn.textContent = originalText;
            }, 2500);
          }
        });
    });
  }

  /* ---- Product Gallery Thumbnails ---- */
  const thumbBtns = document.querySelectorAll('.thumb-btn');
  const featuredImg = document.getElementById('product-featured-image');

  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const src = btn.getAttribute('data-src');
      if (featuredImg && src) {
        featuredImg.style.opacity = '0';
        featuredImg.style.transition = 'opacity 0.2s ease';
        setTimeout(function () {
          featuredImg.src = src;
          featuredImg.style.opacity = '1';
        }, 180);
      }
      thumbBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  /* ---- Quantity Buttons ---- */
  function initQtyButtons(scope) {
    const container = scope || document;
    container.querySelectorAll('.qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const wrapper = btn.closest('.quantity-wrapper');
        const input = wrapper ? wrapper.querySelector('.qty-input') : null;
        if (input) {
          const val = parseInt(input.value) || 1;
          if (val > 1) input.value = val - 1;
        }
      });
    });

    container.querySelectorAll('.qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const wrapper = btn.closest('.quantity-wrapper');
        const input = wrapper ? wrapper.querySelector('.qty-input') : null;
        if (input) {
          const val = parseInt(input.value) || 1;
          input.value = val + 1;
        }
      });
    });
  }

  initQtyButtons();

  /* ---- Cart: Live Quantity Update ---- */
  const cartQtyInputs = document.querySelectorAll('.cart-qty-input');
  cartQtyInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      const key = input.getAttribute('data-key');
      const qty = parseInt(input.value);
      if (!key) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: isNaN(qty) ? 0 : qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          // Reload to update line totals
          window.location.reload();
        })
        .catch(function () {});
    });
  });

  /* ---- Scroll-reveal (simple IntersectionObserver) ---- */
  if ('IntersectionObserver' in window) {
    const revealEls = document.querySelectorAll('.feature-card, .product-card, .product-highlight-inner, .benefits-list li');
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    revealEls.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

})();
